import React from 'react';
type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
};
const ResearchInvertedIcon = function ResearchInvertedIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='research-inverted-icon'>
      <path d="M18.3049 9.1315H20.0147C20.458 9.1315 20.7324 8.6531 20.5002 8.2787L17.3762 3.3491C17.144 2.9955 16.6374 2.9955 16.4052 3.3491L13.2812 8.2787C13.049 8.6531 13.3234 9.1315 13.7667 9.1315H15.4764C15.4764 9.2563 15.4764 9.4019 15.4553 9.5475C15.2654 12.5011 12.8168 14.8931 9.81942 15.0803C6.08326 15.3091 3.02256 12.1891 3.40251 8.5075C3.69802 5.7619 5.89328 3.5571 8.65847 3.2243C9.81942 3.0787 10.9382 3.2659 11.9091 3.7027C12.2258 3.8483 12.6057 3.7235 12.7746 3.4323L13.5345 2.1843C13.7456 1.8515 13.5978 1.3939 13.239 1.2275C11.9936 0.645096 10.6004 0.333096 9.12285 0.395496C4.54235 0.541096 0.785081 4.1603 0.55289 8.6531C0.278482 13.6867 4.35238 17.8883 9.41837 17.8883C14.3155 17.9091 18.3049 13.9779 18.3049 9.1315Z" fill={fillColor} />
    </svg>
  );
};
ResearchInvertedIcon.defaultProps = defaultProps;
export default ResearchInvertedIcon;